var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.disabled && !_vm.value)?_c('span'):_c('el-cascader',{staticClass:"full-w",attrs:{"size":"small","value":_vm.regionMap[_vm.value],"options":_vm.regionOptions,"disabled":_vm.disabled},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }